"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routesLayerId = exports.facilityDistributionMinZoom = exports.facilityDistributionColors = exports.carRoutesLayerId = exports.arrivalLayerId = void 0;
exports.useRouting = useRouting;
exports.wayPointsLayerId = void 0;
var _colors = require("@mui/material/colors");
var _center = _interopRequireDefault(require("@turf/center"));
var _nearestPointOnLine = _interopRequireDefault(require("@turf/nearest-point-on-line"));
var _maplibreGl = require("maplibre-gl");
var _react = _interopRequireWildcard(require("react"));
var _client = require("react-dom/client");
var _reactI18next = require("react-i18next");
var _arrival = _interopRequireDefault(require("../../assets/images/arrival.png"));
var _trainWhite = _interopRequireDefault(require("../../assets/images/poi/train-white.svg"));
var _components = require("../../components");
var _selectedRoutePopup = require("../../components/map/selected-route-popup");
var _wayPointPopup = _interopRequireDefault(require("../../components/map/way-point-popup"));
var _models = require("../../models");
var _utils = require("../../utils");
var _bikeStations = require("./bike-stations");
var _layers = require("./layers");
var _source = require("./source");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const routesSourceId = 'routes';
const routesLayerId = exports.routesLayerId = 'routes';
const carRoutesSourceId = 'car-routes';
const carRoutesLayerId = exports.carRoutesLayerId = 'car-routes';
const wayPointsSourceId = 'way-points';
const wayPointsLayerId = exports.wayPointsLayerId = 'way-points';
const arrivalLayerId = exports.arrivalLayerId = 'arrival-way-point';
const draggedRouteLayerId = 'dragged-route';
const trainRouteLayerId = 'train-route';
const facilityDistributionMinZoom = exports.facilityDistributionMinZoom = 12;
const facilityDistributionColors = exports.facilityDistributionColors = {
  discouraged: '#528be8',
  normal: '#2ac682',
  recommended: '#048760'
};
function useRouting(theme, map, _search, bikeStationsMap = {}, {
  hidePopup,
  selectedTrip: _selectedTrip,
  onSearchUpdated,
  onRouteSelected,
  onContextMenuOpen,
  onTripStepAdded,
  closePopup,
  readOnly,
  disableNewStepAddition,
  routePopupIdSuffix
} = {}, _enabled = true, _layersDrawerOpen = false, onLayersControlToggle = () => undefined) {
  const [initialized, setInitialized] = (0, _react.useState)(false);
  const {
    init: initBikeStations,
    update: updateBikeStations
  } = (0, _bikeStations.useBikeStations)(map, theme);
  const {
    featureCollection: routeSourceCollection,
    addGeoJSONSource: addRoutesSource,
    updateGeoJSONSource: updateRoutesSource,
    clearGeoJSONSource: clearRoutesSource
  } = (0, _source.useSource)(map, routesSourceId);
  const {
    addGeoJSONSource: addCarRoutesSource,
    updateGeoJSONSource: updateCarRoutesSource,
    clearGeoJSONSource: clearCarRoutesSource
  } = (0, _source.useSource)(map, carRoutesSourceId);
  const {
    addGeoJSONSource: addWayPointsSource,
    updateGeoJSONSource: updateWayPointsSource
  } = (0, _source.useSource)(map, wayPointsSourceId);
  const {
    addCircleLayer,
    addLineLayer
  } = (0, _layers.useLayers)(map);
  const search = (0, _react.useRef)(_search);
  const selectedTrip = (0, _react.useRef)(_selectedTrip);
  const hoveredWayPointPopup = (0, _react.useRef)(new _maplibreGl.Popup({
    closeButton: false,
    closeOnClick: false,
    anchor: 'top'
  }));
  const selectedRoutePopup = (0, _react.useRef)(new _maplibreGl.Popup({
    className: 'map-custom-popup route-popup',
    closeButton: false,
    closeOnClick: false
  }));
  const facilityTooltip = (0, _react.useRef)(null);
  const selectedRouteIndex = (0, _react.useRef)(null);
  const draggedWayPointIndex = (0, _react.useRef)(null);
  const wayPointMoved = (0, _react.useRef)(false);
  const enabled = (0, _react.useRef)(_enabled);
  const layersDrawerOpen = (0, _react.useRef)(_layersDrawerOpen);
  const clickTimeout = (0, _react.useRef)(null);
  const routePopupId = `selected-route-popup-${routePopupIdSuffix}`;
  const trainMarkers = (0, _react.useRef)([]);
  const initializedRef = (0, _react.useRef)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  (0, _react.useEffect)(() => {
    search.current = _search;
  }, [_search]);
  (0, _react.useEffect)(() => {
    selectedTrip.current = _selectedTrip;
  }, [_selectedTrip]);
  (0, _react.useEffect)(() => {
    enabled.current = _enabled;
  }, [_enabled]);
  (0, _react.useEffect)(() => {
    layersDrawerOpen.current = _layersDrawerOpen;
  }, [_layersDrawerOpen]);
  function handleWayPointMouseEnter({
    features
  }) {
    if (!map || !features || !features[0] || !features[0].properties) return;
    const {
      geometry,
      properties: {
        index
      }
    } = features[0];
    const wayPoint = search.current.wayPoints[index];
    if (draggedWayPointIndex.current !== index && wayPoint && geometry.type === 'Point' && !hoveredWayPointPopup.current.isOpen()) {
      const {
        coordinates: [lng, lat]
      } = geometry;
      hoveredWayPointPopup.current.setLngLat({
        lat,
        lng
      }).setHTML(`<div id="way-point-popup" style="min-height: 40px;"></div>`).addTo(map);
      const ele = document.getElementById(`way-point-popup`);
      if (!ele) return;
      const container = (0, _client.createRoot)(ele);
      container.render(/*#__PURE__*/_react.default.createElement(_wayPointPopup.default, {
        theme: theme,
        wayPoint: wayPoint
      }));
    }
  }
  function handleArrivalMouseMove(event) {
    const features = map?.queryRenderedFeatures(event.point, {
      layers: [arrivalLayerId]
    });
    if (map && features && features.length > 0) {
      if (features[0].properties?.movable) map.getCanvas().style.cursor = 'move';
      handleWayPointMouseEnter({
        features
      });
    } else if (!map || map.queryRenderedFeatures(event.point, {
      layers: [wayPointsLayerId]
    }).length === 0) {
      if (map) map.getCanvas().style.cursor = '';
      hoveredWayPointPopup.current.remove();
    }
  }
  function handleArrivalMouseDown(event) {
    const features = map?.queryRenderedFeatures(event.point, {
      layers: [arrivalLayerId]
    });
    event.features = features;
    if (map && features && features.length > 0) handleWayPointMouseDown(event);
  }
  function handleWayPointMouseLeave() {
    hoveredWayPointPopup.current.remove();
  }
  function handleWayPointMouseDown(event) {
    const feature = event.features?.[0];
    if (!map || readOnly || feature?.properties?.movable === false || feature?.properties?.isPublicTransports || event.originalEvent.button !== 0) return;
    event.preventDefault();
    map.getCanvas().style.cursor = 'grab';
    hoveredWayPointPopup.current.remove();
    draggedWayPointIndex.current = feature?.properties?.index;
    map.off('click', handleClick);
    map.on('mousemove', handleMove);
    map.once('mouseup', handleDrop);
  }
  function handleRouteMouseMove({
    lngLat,
    features
  }) {
    if (!map || disableNewStepAddition || readOnly || !features?.[0].properties || features[0].properties.isPublicTransports) return;
    const {
      selected,
      facility
    } = features[0].properties;
    if (!selected) map.getCanvas().style.cursor = 'pointer';else map.getCanvas().style.cursor = 'move';
    const zoom = map.getZoom();
    if (selected && facility && zoom >= facilityDistributionMinZoom) addFacilityTooltip(lngLat, t(_models.facilitiesLabels[facility]));
  }
  function handleRouteMouseLeave() {
    if (map && !readOnly && !disableNewStepAddition) map.getCanvas().style.cursor = '';
    clearFacilityTooltip();
  }
  function handleClick(event) {
    if (layersDrawerOpen.current) {
      onLayersControlToggle(false);
      return;
    }
    if (clickTimeout.current) clearTimeout(clickTimeout.current);
    if (enabled.current) {
      clickTimeout.current = setTimeout(() => {
        if (event.originalEvent.defaultPrevented) return;
        const {
          computable,
          wayPoints
        } = search.current;
        if (selectedTrip.current && wayPoints[1]) return;
        event.preventDefault();
        if (computable || layersDrawerOpen.current || !enabled.current) return;
        const {
          lngLat
        } = event;
        const {
          lat,
          lng
        } = lngLat;
        const newWayPoint = new _models.Place(undefined, {
          type: 'Point',
          coordinates: [lng, lat]
        });
        const wayPointIndex = !wayPoints[0] ? 0 : 1;
        wayPoints[wayPointIndex] = newWayPoint;
        const preview = (0, _utils.getRoutePreview)(wayPoints);
        if (!selectedTrip.current) updateWayPoints(wayPoints);
        showPreview(preview, selectedTrip.current && selectedTrip.current.steps?.map((_, index) => index) || []);
        onSearchUpdated?.({
          wayPointIndex
        });
        if (selectedTrip.current && onTripStepAdded) onTripStepAdded(newWayPoint);
      }, 300);
    } else {
      closePopup?.();
    }
  }
  function handleDoubleClick() {
    if (clickTimeout.current) clearTimeout(clickTimeout.current);
  }
  function handleContextMenuOpen({
    point: {
      x,
      y
    },
    lngLat
  }, id) {
    if (onContextMenuOpen) onContextMenuOpen({
      point: [x, y],
      position: lngLat
    }, id);
  }
  function handleMove({
    lngLat
  }) {
    if (!map || draggedWayPointIndex.current === null || readOnly) return;
    map.getCanvas().style.cursor = 'grabbing';
    wayPointMoved.current = true;
    const {
      wayPoints,
      feature: preview
    } = (0, _utils.getDraggedRoutePreview)(search.current.wayPoints, draggedWayPointIndex.current, lngLat);
    search.current.wayPoints = wayPoints;
    updateWayPoints(wayPoints);
    showPreview(preview, selectedTrip.current && selectedTrip.current.steps?.map((_, index) => index).filter(index => index !== selectedRouteIndex.current) || []);
  }
  function handleDrop(event) {
    event.preventDefault();
    if (!map || readOnly) return;
    map.getCanvas().style.cursor = 'pointer';
    if (wayPointMoved.current) {
      onSearchUpdated?.({
        routeIndex: selectedRouteIndex.current
      });
    }
    wayPointMoved.current = false;
    draggedWayPointIndex.current = null;
    map.off('mousemove', handleMove);
    setTimeout(() => map.on('click', handleClick), 200);
  }
  function handleRouteMouseDown(event) {
    if (readOnly || disableNewStepAddition || event.defaultPrevented || event.originalEvent.button !== 0) return;
    event.preventDefault();
    const {
      lngLat: {
        lat,
        lng
      },
      features
    } = event;
    if (!features?.[0]?.properties) return;
    const {
      selected,
      isPublicTransports,
      prevWayPointIndex
    } = features[0].properties;
    if (!selected || isPublicTransports) return;
    if (prevWayPointIndex !== undefined) {
      const index = prevWayPointIndex + 1;
      search.current.wayPoints.splice(index, 0, new _models.Place(undefined, {
        type: 'Point',
        coordinates: [lng, lat]
      }));
      draggedWayPointIndex.current = index;
      handleMove(event);
      map?.off('click', handleClick);
      map?.on('mousemove', handleMove);
      map?.once('mouseup', handleDrop);
    }
  }
  function handleRouteClick(event) {
    if (event.defaultPrevented) return;
    event.preventDefault();
    const {
      features
    } = event;
    if (!features || !features[0] || !features[0].properties) return;
    const {
      selected,
      index
    } = features[0].properties;
    if (!selected && index > -1) {
      onRouteSelected?.(index);
    }
  }
  function init() {
    async function addArrivalMarkerImage() {
      if (!map) return;
      try {
        const image = await map.loadImage(_arrival.default);
        if (!map.hasImage('arrival-marker')) map.addImage('arrival-marker', image.data);
        if (!map.getLayer(arrivalLayerId)) map.addLayer({
          id: arrivalLayerId,
          type: 'symbol',
          source: wayPointsSourceId,
          layout: {
            'icon-image': 'arrival-marker',
            'icon-anchor': 'bottom'
          },
          filter: ['==', 'arrival', true]
        });
        map.on('mousemove', handleArrivalMouseMove);
        map.on('mousedown', handleArrivalMouseDown);
      } catch (err) {
        console.error('err image', err);
      }
    }
    if (!map || initializedRef.current) return;
    addWayPointsSource();
    addArrivalMarkerImage();
    addRoutesSource();
    addCarRoutesSource();
    initBikeStations();
    addCircleLayer(wayPointsLayerId, wayPointsSourceId, {
      'circle-radius': ['get', 'width'],
      'circle-stroke-width': ['get', 'strokeWidth'],
      'circle-stroke-opacity': 1,
      'circle-color': ['get', 'color'],
      'circle-stroke-color': ['get', 'strokeColor']
    }, {
      filter: ['all', ['==', 'wayPoint', true], ['!=', 'arrival', true]]
    });
    map.on('mouseenter', wayPointsLayerId, handleWayPointMouseEnter);
    map.on('mouseleave', wayPointsLayerId, handleWayPointMouseLeave);
    map.on('mousedown', wayPointsLayerId, handleWayPointMouseDown);
    addLineLayer(carRoutesLayerId, carRoutesSourceId, {
      'line-join': 'round',
      'line-cap': 'round'
    }, {
      'line-color': ['get', 'color'],
      'line-width': ['get', 'width']
    });
    addLineLayer(routesLayerId, routesSourceId, {
      'line-join': 'round',
      'line-cap': 'round'
    }, {
      'line-color': ['get', 'color'],
      'line-width': ['get', 'width']
    }, {
      filter: ['all', ['!=', 'dragged', true], ['!=', 'dashArray', true]]
    });
    addLineLayer(trainRouteLayerId, routesSourceId, {
      'line-join': 'round',
      'line-cap': 'round'
    }, {
      'line-color': ['get', 'color'],
      'line-width': ['get', 'width'],
      'line-dasharray': [0.5, 2]
    }, {
      filter: ['all', ['!=', 'dragged', true], ['==', 'dashArray', true]]
    });
    map.on('mousemove', routesLayerId, handleRouteMouseMove);
    map.on('mouseleave', routesLayerId, handleRouteMouseLeave);
    map.on('mousedown', routesLayerId, handleRouteMouseDown);
    addLineLayer(draggedRouteLayerId, routesSourceId, {
      'line-join': 'round',
      'line-cap': 'round'
    }, {
      'line-color': ['get', 'color'],
      'line-width': ['get', 'width'],
      'line-dasharray': [1, 1]
    }, {
      filter: ['==', 'dragged', true]
    });
    map.on('click', handleClick);
    map.on('dblclick', handleDoubleClick);
    map.on('contextmenu', wayPointsLayerId, event => {
      event.preventDefault();
      handleContextMenuOpen(event, event.features?.[0].properties?.index);
    });
    map.on('contextmenu', event => {
      if (event.defaultPrevented) return;
      handleContextMenuOpen(event);
    });
    initializedRef.current = true;
    setInitialized(true);
  }
  function addTrainMarkers(points) {
    if (!map) return;
    points.forEach(point => {
      const element = document.createElement('div');
      element.style.border = '2px solid #fff';
      element.style.borderRadius = '50%';
      element.style.backgroundColor = _colors.lightBlue[500];
      element.style.backgroundImage = `url(${_trainWhite.default})`;
      element.style.backgroundPosition = 'center';
      element.style.backgroundRepeat = 'no-repeat';
      element.style.backgroundSize = '14px';
      element.style.width = '20px';
      element.style.height = '20px';
      element.style.cursor = 'pointer';
      element.addEventListener('click', event => {
        event.stopPropagation();
      });
      const marker = new _maplibreGl.Marker({
        element
      }).setLngLat({
        lat: point[1],
        lng: point[0]
      }).addTo(map);
      trainMarkers.current.push(marker);
    });
  }
  function updateWayPoints(wayPoints) {
    const features = [];
    wayPoints.forEach((wayPoint, index) => {
      if (wayPoint && (!selectedTrip.current || index > 0 && index < wayPoints.length - 1)) {
        const arrival = index === wayPoints.length - 1;
        features.push({
          type: 'Feature',
          geometry: wayPoint.point,
          properties: {
            index,
            color: index === 0 ? '#2ac682' : '#326ac2',
            width: 8,
            strokeColor: '#fff',
            strokeWidth: index === 0 ? 4 : 2,
            wayPoint: true,
            movable: !readOnly && (typeof wayPoint.id !== 'string' || wayPoint.id.indexOf('poi-') !== 0),
            arrival
          }
        });
      }
    });
    updateWayPointsSource({
      type: 'FeatureCollection',
      features
    });
  }
  function showPreview(preview, routeIndexesToKeep = []) {
    selectedRoutePopup.current.remove();
    trainMarkers.current.forEach(marker => {
      marker.remove();
    });
    updateRoutesSource({
      type: 'FeatureCollection',
      features: [...(routeSourceCollection.current?.features.filter(({
        properties: {
          index
        }
      }) => routeIndexesToKeep.indexOf(index) > -1) || []), {
        ...preview,
        properties: {
          ...preview.properties,
          color: '#fff',
          width: 9
        }
      }, {
        ...preview,
        properties: {
          ...preview.properties,
          color: '#326ac2',
          width: 5,
          dragged: true
        }
      }]
    });
  }
  function clearFacilityTooltip() {
    facilityTooltip.current?.remove();
  }
  function addFacilityTooltip(location, title, _offset = 0) {
    clearFacilityTooltip();
    if (!map || !title || hoveredWayPointPopup.current.isOpen()) return;
    const {
      anchor,
      offset
    } = (0, _utils.getAnchorAndOffset)(map, location, _offset);
    facilityTooltip.current = new _maplibreGl.Popup({
      anchor,
      offset,
      className: 'map-tooltip',
      closeButton: false
    }).setHTML(title).setLngLat(location).addTo(map);
  }
  function showRoutes(routes, selectedIndex, {
    showBikeStations,
    enableFacilityDistribution
  } = {}) {
    if (!map) return;
    map.off('click', routesLayerId, handleRouteClick);
    const zoom = map.getZoom();
    selectedRouteIndex.current = selectedIndex;
    trainMarkers.current.forEach(marker => {
      marker.remove();
    });
    const selectedRoute = routes[selectedIndex];
    if (showBikeStations && selectedRoute) updateBikeStations(selectedRoute.bikeStationIds.map(id => bikeStationsMap[id]).filter(Boolean));else updateBikeStations([]);
    const features = [];
    routes.forEach((route, index) => {
      if (!route) return;
      const selected = selectedIndex === index;
      route.sections.forEach(({
        features: sectionFeatures,
        transportMode
      }, sectionIndex) => {
        const isPedestrian = transportMode === 'pedestrian';
        const isPublicTransports = transportMode === 'publicTransports';
        sectionFeatures.forEach(feature => {
          if (selected) {
            const {
              properties: {
                index,
                ...featureProps
              }
            } = feature;
            const borderProps = {
              ...featureProps,
              color: '#fff',
              width: 9,
              sectionIndex,
              index
            };
            features.push({
              ...feature,
              properties: {
                ...borderProps,
                isPublicTransports,
                selected: true
              }
            });
          }
        });
        sectionFeatures.forEach(feature => {
          const {
            properties: {
              index: sectionIndex,
              walking,
              facility,
              ...featureProps
            }
          } = feature;
          const routeProps = {
            ...featureProps,
            width: 5,
            sectionIndex,
            index
          };
          if (selected) {
            features.push({
              ...feature,
              properties: {
                ...routeProps,
                color: isPublicTransports ? _colors.lightBlue[500] : enableFacilityDistribution && facility && zoom >= facilityDistributionMinZoom ? facilityDistributionColors[_models.facilitiesDistribution[facility]] : route.color || '#326ac2',
                dashArray: walking || isPedestrian || isPublicTransports ? true : false,
                isPublicTransports,
                selected: true,
                facility
              }
            });
            if (transportMode === 'publicTransports') {
              addTrainMarkers([feature.geometry.coordinates[0], feature.geometry.coordinates[feature.geometry.coordinates.length - 1]]);
            }
          } else {
            features.splice(0, 0, {
              ...feature,
              properties: {
                ...routeProps,
                color: selectedIndex === -1 && route.color || _colors.blueGrey[300],
                selected: false
              }
            });
          }
        });
        sectionFeatures.forEach(feature => {
          if (!selected) {
            const {
              properties: {
                index: sectionIndex,
                ...featureProps
              }
            } = feature;
            const borderProps = {
              ...featureProps,
              color: '#fff',
              width: 9,
              sectionIndex,
              index
            };
            features.splice(0, 0, {
              ...feature,
              properties: {
                ...borderProps,
                selected: false
              }
            });
          }
        });
      });
    });
    updateRoutesSource({
      type: 'FeatureCollection',
      features
    });
    if (!selectedTrip.current && selectedRoute && !hidePopup) {
      const {
        geometry
      } = selectedRoute;
      const {
        geometry: {
          coordinates: [lng, lat]
        }
      } = (0, _nearestPointOnLine.default)(geometry, (0, _center.default)(geometry));
      selectedRoutePopup.current.setLngLat({
        lat,
        lng
      }).setHTML(`<div id=${routePopupId}></div>`).addTo(map);
      const element = document.getElementById(routePopupId);
      if (element) {
        const container = (0, _client.createRoot)(element);
        container.render(/*#__PURE__*/_react.default.createElement(_selectedRoutePopup.SelectedRoutePopup, {
          routes: selectedRoute,
          theme: theme
        }));
      }
    }
    map.on('click', routesLayerId, handleRouteClick);
  }
  function showCarRoute(carRoute, index, selectedIndex, options = {}) {
    if (!map) return;
    updateCarRoutesSource({
      type: 'FeatureCollection',
      features: [{
        type: 'Feature',
        geometry: carRoute.geometry,
        properties: {
          index,
          color: selectedIndex === index ? _colors.red[500] : _colors.red[200],
          width: 6
        }
      }]
    });
    if (!options.disableTooltip && selectedIndex === index) {
      const {
        geometry: {
          coordinates: [lng, lat]
        }
      } = (0, _nearestPointOnLine.default)(carRoute.geometry, (0, _center.default)(carRoute.geometry));
      selectedRoutePopup.current.setLngLat({
        lat,
        lng
      }).setHTML(`<div id=${routePopupId}></div>`).addTo(map);
      const ele = document.getElementById(routePopupId);
      if (!ele) return;
      const container = (0, _client.createRoot)(ele);
      container.render(/*#__PURE__*/_react.default.createElement(_components.CarRoutePopup, {
        theme: theme
      }));
    }
  }
  function clearRoutes({
    clearBikeStations
  } = {}) {
    selectedRoutePopup.current.remove();
    selectedRouteIndex.current = null;
    clearRoutesSource();
    clearCarRoutesSource();
    if (clearBikeStations) updateBikeStations([]);
    trainMarkers.current.forEach(marker => {
      marker.remove();
    });
  }
  function clear({
    clearBikeStations
  } = {}) {
    clearRoutes({
      clearBikeStations
    });
    clearFacilityTooltip();
    updateWayPoints([]);
    if (clickTimeout.current) clearTimeout(clickTimeout.current);
    hoveredWayPointPopup.current.remove();
    draggedWayPointIndex.current = null;
  }
  function destroy() {
    clear();
    map?.off('mouseenter', wayPointsLayerId, handleWayPointMouseEnter);
    map?.off('mouseleave', wayPointsLayerId, handleWayPointMouseLeave);
    map?.off('mousedown', wayPointsLayerId, handleWayPointMouseDown);
    // map?.off('mouseenter', arrivalLayerId, handleWayPointMouseEnter);
    map?.off('mousemove', handleArrivalMouseMove);
    // map?.off('mouseleave', arrivalLayerId, handleArrivalMouseLeave);
    map?.off('mousedown', arrivalLayerId, handleWayPointMouseDown);
    map?.off('mousemove', routesLayerId, handleRouteMouseMove);
    map?.off('mouseleave', routesLayerId, handleRouteMouseLeave);
    map?.off('mousedown', routesLayerId, handleRouteMouseDown);
    map?.off('click', routesLayerId, handleRouteClick);
    map?.off('click', handleClick);
    map?.off('dblclick', handleDoubleClick);
    map?.off('contextmenu', handleContextMenuOpen);
    initializedRef.current = false;
    setInitialized(false);
  }
  return {
    initialized,
    init,
    updateWayPoints,
    showPreview,
    showCarRoute,
    showRoutes,
    clearRoutes,
    clear,
    destroy
  };
}